import type { ReductionOutcome } from '../../../../schema/coupon/entry.js';

const ScoreReductions: ReductionOutcome[] = ['HOME', 'DRAW', 'AWAY'] as const;
const ReductionScore = ScoreReductions.reduce(
  (reductions, reduction, position) => ({
    ...reductions,
    [reduction]: 1 << position,
  }),
  {
    HOME: 0,
    DRAW: 0,
    AWAY: 0,
  }
);

const filterFn = (h = 0, a = 0): number => h - a;
const homeFilter = (h = 0, a = 0): boolean => filterFn(h, a) > 0;
const drawFilter = (h = 0, a = 0): boolean => filterFn(h, a) === 0;
const awayFilter = (h = 0, a = 0): boolean => filterFn(h, a) < 0;
export const scoreFilterFnMap: Record<number, (a?: number, b?: number) => boolean> = {
  [ReductionScore.HOME]: homeFilter,
  [ReductionScore.DRAW]: drawFilter,
  [ReductionScore.AWAY]: awayFilter,
};
export const NO_REDUCTION = 0;
